<template>
  <span>
    <v-text-field
      v-if="!readonly"
      class="d-inline-block mx-2"
      required
      dense
      hide-details
      height="14px"
      style="min-width: 20px;"
      v-model="code"
      type="number"
      @change="onQueryChange"
      @mouseup="onQueryChange"
    />
    <span v-else>{{ code }} </span>
  </span>
</template>

<script>
export default {
  name: "AcornCode",
  props: {
    onQueryChange: {
      type: Function,
      required: true,
    },
    initialConfig: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      code: 1,
    };
  },
  methods: {
    onChangeInitialConfig() {
      if(this.initialConfig.code) {
        this.code = this.initialConfig.code
      }
    },
    getQuery() {
      return {
        code: +this.code,
      };
    },
  },
  watch: {
    initialConfig: {
      handler() {
        this.onChangeInitialConfig()
      },
    immediate: true,
    },
    code() {
      this.onQueryChange()
    }
  }
};
</script>
